<template lang="pug">
//- お知らせ一覧ページ
.announcements
  .common-h1-area
    HeadingBlock(level="1" text="Notifications")
    p.heading-block-sub(v-if="this.$i18n.locale === 'ja'") {{$t("お知らせ")}}
  .sub-page-padding
    .container
      AnnouncementBlock(:perPage="10")
</template>

<script>
import HeadingBlock from '@/components/HeadingBlock'
import AnnouncementBlock from '@/components/AnnouncementBlock'

export default {
  components: {
    HeadingBlock,
    AnnouncementBlock,
  },
  data() {
    return {
      announcements: [],
    }
  },
  methods: {},
  created() {},
}
</script>

<style lang="scss" scoped></style>
